import { Box, Container, Grid } from "@mui/material";
import { PageTitle } from "../../commanComponents/PageTitle";
import { LinearProgressBar } from "../../commanComponents/LinearProgressBar";
import { String } from "../../constants/Strings";
import {
  ACRButtonStyles,
  InputLabelProps,
  InputProps,
  StyledBox,
  StyledButtonBox,
  StyledCheckbox,
  StyledFormBox,
  StyledTypography,
  StyleSpanText,
  UserTextFields,
} from "./YourLiabilitisStyle";
import ACRButton from "../../commanComponents/ACRButton";
import { useEffect, useState } from "react";
import { OTPScreen } from "../onbording/OTPScreen";
import { useNavigate } from "react-router-dom";
import CustomSnackbar from "../../commanComponents/CustomerSnackbar";
import { getColor } from "../../style/color/color";
import { fonts } from "../../style/fonts/fonts";

const YourLiabilities = () => {
  const [open, setOpen] = useState(false);
  const [otp, setOtp] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOTPEnter, setSnackbarOTPEnter] = useState(false);
  const [timer, setTimer] = useState(30);
  const [UserData, setUserData] = useState({
    MobileNumber: "",
    FullName: "",
    PAN: "",
  });
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();
  // setShowSnackbar(true);
  // setSnackbarMessage({
  //   message: "Account details fetch successfully",
  //   severity: "success",
  // });
  const handleAuthorize = () => {
    if (!otp) {
      setSnackbarOTPEnter(true);
      setSnackbarMessage("Please enter the OTP."); // Set a meaningful error message
      return;
    } else if (otp.length !== 4) {
      setSnackbarOTPEnter(true);
      setSnackbarMessage("OTP must be 4 digits long."); // Set a specific error message for length
      return;
    }
    setTimeout(() => {
      setOpenSnackbar(false);
      navigate("/thankyou");
    }, 2000);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleClose = () => {
    setOpen(false);
  };

  const handleOTPChange = (otpValue) => {
    setOtp(otpValue);
  };
  const startTimer = () => {
    let newIntervalId = null;
    if (newIntervalId) {
      clearInterval(newIntervalId); // Clear any existing interval
    }

    newIntervalId = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer > 0) {
          return prevTimer - 1;
        } else {
          clearInterval(newIntervalId); // Stop the timer when it reaches 0
          return 0;
        }
      });
    }, 1000);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "MobileNumber" && !/^\d*$/.test(value)) {
      return;
    }
    if (name === "PAN" && /[^A-Za-z0-9]/.test(value)) {
      setSnackbarMessage("PAN must contain only letters and numbers.");
      setOpenSnackbar(true);
      return;
    }
    setUserData((prevData) => ({ ...prevData, [name]: value.toUpperCase() }));
  };
  const handleClick = () => {
    if (!/^\d{10}$/.test(UserData.MobileNumber)) {
      setSnackbarMessage("Please enter a valid 10-digit mobile number.");
      setOpenSnackbar(true);
      return;
    }

    if (!UserData.FullName.trim()) {
      setSnackbarMessage("Full Name cannot be empty.");
      setOpenSnackbar(true);
      return;
    }
    if (!UserData.PAN.trim()) {
      setSnackbarMessage("PAN cannot be empty.");
      setOpenSnackbar(true);
      return;
    }

    if (!isChecked) {
      setSnackbarMessage("Please check the authorization checkbox.");
      setOpenSnackbar(true);
      return;
    }

    setOpen(true);
    startTimer();
  };
  return (
    <StyledBox>
      <Container sx={{ flexGrow: 1, padding: { xs: "16px", sm: "32px" } }}>
        <PageTitle PageTitle={String.AccountAggregator.CibilScore.Title} />
        <LinearProgressBar
          dragMessage={String.AccountAggregator.CibilScore.dragMessage}
          progress={80}
          progressNumber={80}
          stepNumber={2}
        />
      </Container>
      <StyledFormBox>
        <Grid container spacing={2} sx={{ width: "100%" }}>
          <Grid item xs={12}>
            <UserTextFields
              label={String.AccountAggregator.CibilScore.labelName1}
              variant="outlined"
              name="MobileNumber"
              value={UserData.MobileNumber}
              onChange={handleInputChange}
              type="tel"
              fullWidth
              InputLabelProps={InputLabelProps}
              InputProps={{
                ...InputProps,
                inputProps: {
                  maxLength: 10,
                  pattern: "[0-9]*",
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <UserTextFields
                label={String.AccountAggregator.CibilScore.labelName2}
                variant="outlined"
                name="FullName"
                value={UserData.FullName}
                onChange={handleInputChange}
                fullWidth
                InputLabelProps={InputLabelProps}
                InputProps={InputProps}
              />
              <span
                style={{
                  position: "absolute",
                  right: "85%",
                  top: "85%",
                  transform: "translateY(-50%)",
                  color: getColor.SecondaryMidnightBlue,
                  fontSize: "0.625rem",
                  fontFamily: fonts.manrope,
                  fontWeight: "500",
                }}
              >
                As per PAN
              </span>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <UserTextFields
              label={String.AccountAggregator.CibilScore.labelName3}
              variant="outlined"
              name="PAN"
              value={UserData.PAN}
              onChange={handleInputChange}
              fullWidth
              InputLabelProps={InputLabelProps}
              InputProps={InputProps}
            />
          </Grid>
        </Grid>
      </StyledFormBox>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
          position: "relative",
        }}
      >
        <StyledCheckbox
          size="large"
          value={isChecked}
          onChange={() => setIsChecked(true)}
        />
        <StyledTypography>
          I authorize Max Life to send this information via a private and
          secured service to fecth credit report and agree to{" "}
          <StyleSpanText>Consent Terms,</StyleSpanText> and{" "}
          <StyleSpanText>Max Life Terms and Condition</StyleSpanText>
        </StyledTypography>
      </Box>
      <StyledButtonBox>
        <ACRButton
          label={String.AccountAggregator.CibilScore.buttonName}
          style={ACRButtonStyles}
          onClickButton={handleClick}
        />
      </StyledButtonBox>
      <OTPScreen
        openDialog={open}
        otp={otp}
        handleClose={handleClose}
        onOTPHandleChange={handleOTPChange}
        handleAuthorize={handleAuthorize}
        OpenSnackbar={openSnackbar}
        setOpenopenSnackbar={setOpenSnackbar}
        title={String.OTPScreen.Title}
        snackbarOTPEnter={snackbarOTPEnter}
        setSnackbarOTPEnter={setSnackbarOTPEnter}
        message={"OTP Verfied Successfully"}
        timer={timer}
      ></OTPScreen>

      <CustomSnackbar
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
        message={snackbarMessage}
        severity={"error"}
      />
    </StyledBox>
  );
};

export default YourLiabilities;
